import { makeStyles, Theme } from "@material-ui/core";
import { Colors } from "constants/constants";
import Background from "icon/background.jpeg";

export const useAuthPageStyles = makeStyles((theme: Theme) => ({
  root: {
    background: "#EDF2F7",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    minHeight: "100vh",
    height: "100%",
  },
  authBox: {
    width: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(6, 4),
    boxSizing: "border-box",
  },
  box: {
    width: "50%",
    height: "100vh",
    boxSizing: "border-box",
    display: "flex",
    backgroundImage: `url(${Background})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  textContent: {
    width: "100%",
    padding: theme.spacing(5),
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "10px",
  },
  title: {
    fontSize: "35px",
    fontWeight: 500,
    color: "#fff",
    lineHeight: "44px",
  },
  "@media (max-width: 1280px)": {
    root: {
      flexDirection: "column-reverse",
      justifyContent: "start",
    },
    authBox: {
      width: "100%",
    },
    box: {
      width: "100%",
      height: "auto",
    },
    textContent: {
      height: 200,
      padding: theme.spacing(0, 4),
    },
    title: {
      display: "none",
    },
  },
}));

export const useAuthFormStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 400,
  },
  title: {
    fontSize: 36,
    fontWeight: 400,
    margin: 0,

  },
  description: {
    marginTop: theme.spacing(4),
    fontWeight: 400,
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  label: {
    color: "#5F6164",
    margin: theme.spacing(4, 0, 0.5),
    fontSize: 14,
  },
  error: {},
  authBtn: {
    fontSize: 16,
    width: "100%",
  },
  resetFormSection: {
    display: "flex",
    flexDirection: "column",
  },
  backBtn: {
    color: "black",
    borderRadius: theme.spacing(1),
    width: "fit-content",
    marginBottom: theme.spacing(4),
  },

  successColor: {
    "&.MuiInput-underline:after": {
      borderBottom: `2px solid ${Colors.SUCCESS_TOAST_GREEN}`,
    },
    "&.MuiInput-underline:before": {
      borderBottom: `1px solid ${Colors.SUCCESS_TOAST_GREEN}`,
    },
    "&.MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: `1px solid ${Colors.SUCCESS_TOAST_GREEN}`,
    },
  },

  "@media (max-width: 1280px)": {
    title: {
      margin: "40px 0 0",
    },
    resetFormSection: {
      flexDirection: "column-reverse",
    },
    backBtn: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(0),
    },
  },
}));
